import PropTypes from 'prop-types';
import React from 'react';

import { Row, Col } from 'twyne-new.ui';

import { templateAlias } from '../formUtils';
import forms from '../forms';

import AlertPlacement from './AlertPlacement';
import ImportPlacement from './ImportPlacement';

const StandardTab = ({ disabled, type, data, integrationData, integration, handleChangeForm, sanitary, handleClickRestorePlacement, handleImportPlacement, handleCustomField, onChangeContent, onCompilerError }) => {
  const vendor = templateAlias[type]
  const StandardForm = forms[vendor]

  if (!StandardForm) {
    return null
  }

  return (
    <Row>
      <Col size="12">
        <StandardForm data={data} integrationData={integrationData} integration={integration} onChange={handleChangeForm} disabled={!sanitary || disabled} onCustomFieldClick={handleCustomField} onChangeContent={onChangeContent} onCompilerError={onCompilerError} />
        <ImportPlacement disabled={disabled} vendor={vendor} onSubmit={handleImportPlacement} />
        <AlertPlacement show={!sanitary} onClick={handleClickRestorePlacement} />
      </Col>
    </Row>
  );
};

StandardTab.propTypes = {
  type: PropTypes.string,
  show: PropTypes.bool,
  integrationData: PropTypes.object,
  handleChangeForm: PropTypes.func,
  sanitary: PropTypes.bool,
  handleClickRestorePlacement: PropTypes.func,
  handleImportPlacement: PropTypes.func,
  handleCustomField: PropTypes.func,
};

export default StandardTab;
